export default __webpack_public_path__ + "static/media/ILUSTRACIONES_08.968dd614.png";